import { paramCase } from 'change-case';
import { pluralize } from '@xbcb/js-utils';

export const recordTypeToPath = (recordType: string) =>
  `/${paramCase(pluralize(recordType))}`;
